import React, { FC } from 'react';
import TextInput from '../TextInput';
import { SafeAreaView, TextInputProps } from 'react-native';
import styles from './styles';

type UserLogoInputProps = {
  errorMessage?: string | boolean;
  value: string;
  onBlur: Function;
  onChangeText: Function;
};

export type InputProps = UserLogoInputProps & TextInputProps;

export const UserLogoInput: FC<InputProps> = (props) => {
  const { errorMessage, onBlur, onChangeText, value } = props;
  return (
    <SafeAreaView>
      <TextInput
        errorMessage={errorMessage}
        imageKey={'user'}
        imageStyle={styles.imageStyle}
        keyboardType="default"
        label="Name"
        labelHidden
        onBlur={onBlur}
        onChangeText={onChangeText}
        placeholder="Name"
        value={value}
        textContentType="name"
        autoCapitalize="words"
        autoCompleteType="name"
        autoCorrect
      />
    </SafeAreaView>
  );
};

export default UserLogoInput;
